export class GenerateShippingGuideReportInput {
  orderIds: number[];
  version?: number;
  userId?: number|null;
}